// extracted by mini-css-extract-plugin
export default {"content":"style_content__+Z4ND","itemName":"style_itemName__NUjT4","leftSide":"style_leftSide__WHEsQ","rightSide":"style_rightSide__H8szj","type":"style_type__oO5uC"};